// extracted by mini-css-extract-plugin
export default {"spinner-container":"spinner-container--lGCt8"};